/* eslint max-len: ["error", { "code": 150 }] */
/* eslint no-underscore-dangle: ["error", { "allow": ["_myID", "_id", "_fetchedMemberIds",
 "_fetchedMembersPage", "_maxListeners", "_submitOnEnter", "_overConversationLimit", "_hasPaid",
 "_limitedMessages", "_loading", "_usersNotFound", "_error", "_showDistance", "_loadNextPage",
 "_searchedMembersPage", "_searchedMembersPageNext", "_searchedMembersPagePrevious",
 "_biggestActivePage", "_totalItemsCount", "_morePages", "_fetchedMemberIdsPage", "_searchedMemberIds",
 "_members", _memberQuestions] }] */
/* eslint func-names: ["error", "never"] */
import _ from 'lodash';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
/* import ConversationStore from './ConversationStore'; */

const { ActionTypes } = Constants;
const CHANGE_EVENT = 'change'; // globālais
const CHANGE_MEMBER_EVENT = 'changeMember'; // tikai, tiem kuri saistīti ar lietotāju datiem, piem. memberImage, memberName
const CHANGE_QUESTION_EVENT = 'changeQuestions';
const CHANGE_MEMBER_QUESTIONS_EVENT = 'changeMemberQuestions';

const _members = {};
const _memberQuestions = {};
let _fetchedMemberIds = [];
let _searchedMemberIds = [];
let _fetchedMemberIdsPage = [];
let _fetchedMembersPage = 1;
let _searchedMembersPage = 1;
let _searchedMembersPageNext = null;
let _searchedMembersPagePrevious = null;
const _biggestActivePage = { default: 1 };
const _totalItemsCount = { default: null };
const _morePages = { default: true };
let _loading = false;
let _usersNotFound = false;
let _error = false;
let _showDistance = false;
let _loadNextPage = true;
let _myID = null;
let _limitedMessages = false; // vai ir ierobežotas darbības ar vēstulēm
let _hasPaid = true; // vai maksātājs
let _overConversationLimit = false; // vai pāri sarakstu limitam
let _submitOnEnter = false; // submit vēstulei, ja nospiests enter
EventEmitter.prototype._maxListeners = 0; // neierobežots eventu daudzums
const questionsData = {};

const MemberStore = assign({}, EventEmitter.prototype, {

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  emitChangeMember() {
    this.emit(CHANGE_MEMBER_EVENT);
  },

  emitChangeQuestion() {
    this.emit(CHANGE_QUESTION_EVENT);
  },

  emitChangeMemberQuestions() {
    this.emit(CHANGE_MEMBER_QUESTIONS_EVENT);
  },

  /**
  * @param {function} callback
  */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  addChangeMemberListener(callback) {
    this.on(CHANGE_MEMBER_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  addChangeQuestionListener(callback) {
    this.on(CHANGE_QUESTION_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  addChangeMemberQuestionsListener(callback) {
    this.on(CHANGE_MEMBER_QUESTIONS_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeQuestionListener(callback) {
    this.removeListener(CHANGE_QUESTION_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeMemberListener(callback) {
    this.removeListener(CHANGE_MEMBER_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeMemberQuestionsListener(callback) {
    this.removeListener(CHANGE_MEMBER_QUESTIONS_EVENT, callback);
  },

  addMember(member) {
    if (!_members[member._id]) _members[member._id] = {};

    // default vērtības
    const memberDefault = {
      _id: null,
      age: null,
      blocked: false,
      ignored: false,
      favorite: false,
      can_access: false,
      image: null,
      name: '',
      sex: null,
      status: 'delete',
      answer_score: 0,
      has_paid: false,
      deleted: false,
      location: '',
      image_count: 0,
      about_me: '',
      was_messaged_by_me: false,
      was_visited_by_me: false,
      km_from_me: null,
      admin: [],
    };

    // console.log(member);

    _members[member._id] = _.assign(memberDefault, member);

    // pievieno savu id
    if (member.my_id && !_myID) {
      _myID = member.my_id;
    }
  },

  addMembers(members, group, page, previous = false) {
    if (previous) {
      members.reverse();
    }

    members.forEach(function (member) {
      if (group === 'searched') {
        this.addSearchedMemberId(member._id, previous);
        if (_.has(_members, member._id)) {
          return;
        }
      }
      if (group === 'fetched') {
        this.addFetchedMemberId(member._id);
        if (_.has(_members, member._id)) {
          return;
        }
      }
      this.addMember(member);
    }, this);

    if (group === 'fetched' && this.getFetchedMemberPage(page) === false) {
      this.addFetchedMemberPage(members, page);
    }
  },

  addMemberQuestions(id, questions) {
    _memberQuestions[id] = questions;
  },

  addSearchedMemberId(memberId, previous = false) {
    if (previous) {
      _searchedMemberIds.unshift(memberId);
      return;
    }
    _searchedMemberIds.push(memberId);
  },

  addFetchedMemberId(memberId) {
    _fetchedMemberIds.push(memberId);
  },

  addFetchedMemberPage(members, page) {
    members.forEach(function (member) {
      if (!_fetchedMemberIdsPage[page]) _fetchedMemberIdsPage[page] = [];
      _fetchedMemberIdsPage[page].push(this.get(member._id));
    }, this);
  },

  getFetchedMemberPage(page) {
    if (!_fetchedMemberIdsPage[page]) {
      return false;
    }

    return _fetchedMemberIdsPage[page];
  },

  addFetchedMember(memberId) {
    _fetchedMemberIds.push(memberId);
  },

  setLimitedMessages(value) {
    _limitedMessages = value;
  },

  setHasPaid(value) {
    _hasPaid = value;
  },

  setOverConversationLimit(value) {
    _overConversationLimit = value;
  },

  /**
  * Mainīt can_access statusu
  * @param {string} memberId
  * @param {boolean} value
  */
  setCanAccess(memberId, value) {
    if (!_members[memberId]) {
      return false;
    }

    _members[memberId].can_access = value;
    return true;
  },

  /**
  * Mainīt blocked statusu
  * @param {string} memberId
  * @param {boolean} value
  */
  setBlocked(memberId, value) {
    if (!_members[memberId]) {
      return false;
    }

    _members[memberId].blocked = value;
    return true;
  },

  /**
  * Mainīt ignored statusu
  * @param {string} memberId
  * @param {boolean} value
  */
  setIgnored(memberId, value) {
    if (!_members[memberId]) {
      return false;
    }

    _members[memberId].ignored = value;
    return true;
  },

  /**
  * Vai sūtīt vēstuli, ja nospiests enter
  * @param {boolean} value
  */
  setSubmitOnEnter(value) {
    if (!_.isBoolean(value)) {
      return false;
    }
    _submitOnEnter = value;
    return true;
  },

  /**
   * Vai pašlaik ielādē lietotājus
   * @param {boolean} value
   */
  setLoading(value) {
    if (!_.isBoolean(value)) {
      return false;
    }
    _loading = value;

    return _loading;
  },

  /**
   * Vai rādīt ziņu, ka meklētie lietotāji nav atrasti
   * @param {boolean} value
   */
  setUsersNotFound(value) {
    if (!_.isBoolean(value)) {
      return false;
    }
    _usersNotFound = value;

    return _usersNotFound;
  },

  /**
   * Vai rādīt error ziņu
   * @param {boolean} value
   */
  setError(value) {
    if (!_.isBoolean(value)) {
      return false;
    }
    _error = value;

    return _error;
  },

  /**
   * Vai rādīt attālumu starp lietotājiem
   * @param {boolean} value
   */
  setShowDistance(value) {
    if (!_.isBoolean(value)) {
      return false;
    }
    _showDistance = value;

    return _showDistance;
  },

  /**
   * Vai ielādēt arī nākamo lapu
   * @param {boolean} value
   */
  setLoadNextPage(value) {
    if (!_.isBoolean(value)) {
      return false;
    }
    _loadNextPage = value;

    return _loadNextPage;
  },

  /**
   * Set last searched members page
   */
  setSearchedMembersPage(value) {
    _searchedMembersPage = parseInt(value); // eslint-disable-line radix
  },

  /**
   * Set last "Next" searched members page
   */
  setSearchedMembersPageNext(value) {
    _searchedMembersPageNext = parseInt(value); // eslint-disable-line radix
  },

  /**
   * Set last "Previous" searched members page
   */
  setSearchedMembersPagePrevious(value) {
    _searchedMembersPagePrevious = parseInt(value); // eslint-disable-line radix
  },

  setFetchedMembersPage(value) {
    _fetchedMembersPage = parseInt(value); // eslint-disable-line radix
  },

  /**
  * @param {string} id
  */
  get(id) {
    return _members[id];
  },

  /**
  * @param {string} id
  */
  getMemberQuestions(id) {
    return _memberQuestions[id];
  },

  getAll() {
    return _members;
  },

  getAllFetched(membersIdsArray) {
    if (!membersIdsArray.length) {
      return {};
    }
    const fetched = {};
    const allFetchedMemberIds = MemberStore.getAllIds();
    let membersIds = membersIdsArray;

    if (typeof membersIds !== 'undefined' && Object.keys(membersIds).length > 0) {
      membersIds = JSON.parse(membersIds);

      membersIds.forEach(function (id, index) {
        const member = this.get(id);
        if (typeof member !== 'undefined') {
          // Neizmanto id, jo pie statistikas ir vienādi lietotāji
          fetched[index] = member;
          // fetched[id] = member;
        }
      }, this);
    } else if (allFetchedMemberIds != null) {
      console.log('two');
      allFetchedMemberIds.forEach(function (id, index) {
        if (_myID !== id && Object.keys(membersIds).length > 0 && membersIds.indexOf(id) !== -1) {
          // Neizmanto id, jo pie statistikas ir vienādi lietotāji
          fetched[index] = this.get(id);
          // fetched[id] = this.get(id);
        } else if (_myID !== id) {
          // Neizmanto id, jo pie statistikas ir vienādi lietotāji
          fetched[index] = this.get(id);
          // fetched[id] = this.get(id);
        }
      }, this);
    }
    return fetched;
  },

  getFetchedPage() {
    const fetched = {};
    _fetchedMemberIds = _.uniq(_fetchedMemberIds);
    _fetchedMemberIds.forEach(function (id) {
      if (_myID !== id) {
        fetched[id] = this.get(id);
      }
    }, this);

    return fetched;
  },

  /*
  * Atgriež visu lietotāju id vērtības
  */
  getAllIds() {
    if (_.isEmpty(_members)) {
      return null;
    }

    return _.map(_members, '_id');
  },

  getMyID() {
    return _myID;
  },

  getMyProfile() {
    return _members[_myID];
  },

  getCanAccess(memberId) {
    if (!_members[memberId]) {
      return false;
    }

    return _members[memberId].can_access;
  },

  getBlocked(memberId) {
    if (!_members[memberId]) {
      return null;
    }

    return _members[memberId].blocked;
  },

  getIgnored(memberId) {
    if (!_members[memberId]) {
      return null;
    }

    return _members[memberId].ignored;
  },

  getLimitedMessages() {
    return _limitedMessages;
  },

  getHasPaid() {
    return _hasPaid;
  },

  getOverConversationLimit() {
    return _overConversationLimit;
  },

  getSubmitOnEnter() {
    return _submitOnEnter;
  },

  getLoading() {
    return _loading;
  },

  getUsersNotFound() {
    return _usersNotFound;
  },

  getError() {
    return _error;
  },

  getShowDistance() {
    return _showDistance;
  },

  getLoadNextPage() {
    return _loadNextPage;
  },

  getAllSearched() {
    const searched = [];
    _searchedMemberIds = _.uniq(_searchedMemberIds);
    _searchedMemberIds.forEach(function (id) {
      if (_myID !== id) {
        searched.push(this.get(id));
      }
    }, this);

    return searched;
  },

  /**
   * Return last searched members page
   */
  getSearchedMembersPage() {
    return _searchedMembersPage;
  },

  /**
   * Return last "Next" searched members page
   */
  getSearchedMembersPageNext() {
    return _searchedMembersPageNext;
  },

  /**
   * Return last "Previous" searched members page
   */
  getSearchedMembersPagePrevious() {
    return _searchedMembersPagePrevious;
  },

  getFetchedMembersPage() {
    return _fetchedMembersPage;
  },

  /**
   * Iestata lielāko apskatīto lapu (priekš pagination)
   */
  setBiggestActivePage(value, section = 'default') {
    _biggestActivePage[section] = parseInt(value); // eslint-disable-line radix
  },

  /**
   * Set total count of items/members
   */
  setTotalItemsCount(value, section = 'default') {
    _totalItemsCount[section] = value;
  },

  /**
   * Atgriež lielāko apskatīto lapu (priekš pagination)
   */
  getBiggestActivePage(section = 'default') {
    if (Object.prototype.hasOwnProperty.call(_biggestActivePage, section)) {
      return _biggestActivePage[section];
    }

    return _biggestActivePage.default;
  },

  /**
   * Get total count of items/members
   */
  getTotalItemsCount(section = 'default') {
    if (Object.prototype.hasOwnProperty.call(_totalItemsCount, section)) {
      return _totalItemsCount[section];
    }

    return _totalItemsCount.default;
  },

  /**
   * Iestata, vai rādīt pagination beigās '...'
   */
  setMorePages(value, section = 'default') {
    _morePages[section] = value;
  },

  /**
   * Atgriež, vai rādīt pagination beigās '...'
   */
  getMorePages(section = 'default') {
    if (Object.prototype.hasOwnProperty.call(_morePages, section)) {
      return _morePages[section];
    }

    return _morePages.default;
  },

  removeSearchedMemberIds() {
    _searchedMemberIds = [];
  },

  removeFetchedMemberIds() {
    _fetchedMemberIds = [];
  },

  removeFetchedMemberIdsPage(page) {
    if (page === 'all') {
      _fetchedMemberIdsPage = [];
    } else {
      _fetchedMemberIdsPage[page] = [];
    }
  },

  getQuestionsData() {
    return questionsData;
  },

  addQuestionsData(questions, additionalQuestions) {
    questionsData.questions = questions;
    questionsData.additional_questions = additionalQuestions;
  },

});

MemberStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.MEMBERS_LOAD_SUCCESS: {
      const count = action.members.length;
      let doEmitChange = false;

      if (count > 0) {
        const limitMessages = action.limitedMessages;
        const { hasPaid } = action;
        const { overConversationLimit } = action;
        // lietotāji pirms pievienošanas
        const oldMembersData = _.clone(MemberStore.getAll());

        if (action.page) {
          MemberStore.setFetchedMembersPage(action.page);
        }

        MemberStore.addMembers(action.members);

        if (typeof hasPaid !== 'undefined') {
          MemberStore.setHasPaid(hasPaid);
        }
        // ja mainās limitMessages vērtība, tad globālais change
        if (typeof limitMessages !== 'undefined' && limitMessages !== MemberStore.getLimitedMessages()) {
          MemberStore.setLimitedMessages(limitMessages);
          doEmitChange = true;
        } else if (typeof overConversationLimit !== 'undefined' && overConversationLimit !== MemberStore.getOverConversationLimit()) {
          MemberStore.setOverConversationLimit(overConversationLimit);
          doEmitChange = true;
        } else {
          // Ja pievienotie dati atšķiras
          if (_.isEmpty(oldMembersData) || !_.isEqual(MemberStore.getAll(), oldMembersData)) { // eslint-disable-line no-lonely-if
            MemberStore.emitChangeMember();
          }
        }
      }

      if (action.submitOnEnter !== MemberStore.getSubmitOnEnter()) {
        MemberStore.setSubmitOnEnter(action.submitOnEnter);
        doEmitChange = true;
      }

      MemberStore.setLoading(false);

      if (doEmitChange) {
        MemberStore.emitChange();
      }
      break;
    }
    case ActionTypes.MEMBERS_FETCH_SUCCESS: {
      if (!MemberStore.getLoading()) {
        break;
      }
      if (action.members.length) {
        if (action.page) {
          MemberStore.setFetchedMembersPage(action.page);
        }

        MemberStore.removeFetchedMemberIds();
        MemberStore.addMembers(action.members, 'fetched', action.page);
        MemberStore.setUsersNotFound(false);
      } else {
        MemberStore.removeFetchedMemberIds();
        MemberStore.setUsersNotFound(true);
      }

      MemberStore.setLoading(false);
      MemberStore.setError(false);

      MemberStore.emitChange();
      break;
    }
    case ActionTypes.MEMBERS_FETCH_FAIL: {
      MemberStore.removeFetchedMemberIds();

      MemberStore.setUsersNotFound(false);
      MemberStore.setError(true);
      MemberStore.setLoading(false);

      MemberStore.emitChange();
      break;
    }
    case ActionTypes.MESSAGES_LOAD_SUCCESS: {
      // AppDispatcher.waitFor([MessageStore.dispatchToken]);
      const limitMessages = action.limitedMessages;
      const { overConversationLimit } = action;

      if (typeof limitMessages !== 'undefined' && limitMessages !== MemberStore.getLimitedMessages()) {
        MemberStore.setLimitedMessages(limitMessages);
        MemberStore.emitChange();
      } else if (typeof overConversationLimit !== 'undefined' && overConversationLimit !== MemberStore.getOverConversationLimit()) {
        MemberStore.setOverConversationLimit(overConversationLimit);
        /* const doEmitChange = true; */
      }
      break;
    }
    case ActionTypes.MEMBER_BLOCK: {
      if (action.success && action.memberId) {
        MemberStore.setBlocked(action.memberId, true);
        if (typeof action.canAccess === 'boolean') {
          MemberStore.setCanAccess(action.memberId, action.canAccess);
        }
        MemberStore.emitChangeMember();
      }
      break;
    }
    case ActionTypes.MEMBER_UNBLOCK: {
      if (action.success && action.memberId) {
        MemberStore.setBlocked(action.memberId, false);
        if (typeof action.canAccess === 'boolean') {
          MemberStore.setCanAccess(action.memberId, action.canAccess);
        }
        MemberStore.emitChangeMember();
      }
      break;
    }
    case ActionTypes.MEMBER_IGNORE: {
      if (action.success && action.memberId) {
        MemberStore.setIgnored(action.memberId, true);
        MemberStore.emitChangeMember();
      }
      break;
    }
    case ActionTypes.MEMBER_UNIGNORE: {
      if (action.success && action.memberId) {
        MemberStore.setIgnored(action.memberId, false);
        MemberStore.emitChangeMember();
      }
      break;
    }
    case ActionTypes.CONVERSATIONS_LOAD_SUCCESS: {
      // AppDispatcher.waitFor([ConversationStore.dispatchToken]);
      const limitMessages = action.limitedMessages;
      const { overConversationLimit } = action;

      if (typeof limitMessages !== 'undefined' && limitMessages !== MemberStore.getLimitedMessages()) {
        MemberStore.setLimitedMessages(limitMessages);
        MemberStore.emitChange();
      } else if (typeof overConversationLimit !== 'undefined' && overConversationLimit !== MemberStore.getOverConversationLimit()) {
        MemberStore.setOverConversationLimit(overConversationLimit);
        /* let doEmitChange = true; */
      }
      break;
    }
    case ActionTypes.SUBMIT_ON_ENTER: {
      if (action.value !== MemberStore.getSubmitOnEnter()) {
        MemberStore.setSubmitOnEnter(action.value);
      }

      break;
    }
    case ActionTypes.SEARCHED_MEMBERS_LOAD: {
      MemberStore.setLoading(true);
      MemberStore.emitChange();
      break;
    }
    case ActionTypes.SEARCHED_MEMBERS_LOAD_SUCCESS: {
      if (action.members.length > 0) {
        MemberStore.addMembers(action.members, 'searched', action.page, action.previous);
      }
      if (action.page) {
        MemberStore.setSearchedMembersPage(action.page);

        if (!MemberStore.getSearchedMembersPageNext()) {
          MemberStore.setSearchedMembersPageNext(action.page);
        }

        if (!MemberStore.getSearchedMembersPagePrevious()) {
          MemberStore.setSearchedMembersPagePrevious(action.page);
        }
      }
      MemberStore.setLoading(false);
      MemberStore.emitChange();

      break;
    }
    case ActionTypes.SEARCHED_MEMBERS_LOAD_FAIL: {
      MemberStore.setLoading(false);
      MemberStore.emitChange();
      break;
    }
    case ActionTypes.MEMBERS_FETCH_LOADED_PAGE: {
      const members = MemberStore.getFetchedMemberPage(action.page);
      const count = members.length;
      let doEmitChange = false; // eslint-disable-line no-redeclare

      if (count > 0) {
        MemberStore.setFetchedMembersPage(action.page);
        doEmitChange = true;

        MemberStore.removeFetchedMemberIds();
        MemberStore.addMembers(members, 'fetched', action.page);
      }

      MemberStore.setLoading(false);
      MemberStore.setError(false);
      if (doEmitChange) {
        MemberStore.emitChange();
      }
      break;
    }
    case ActionTypes.MEMBERS_FETCH_NEXT_PAGE_SUCCESS: {
      const count = action.members.length; // eslint-disable-line no-redeclare

      if (count > 0) {
        MemberStore.addMembers(action.members, 'fetched', action.page);
      }
      break;
    }
    case ActionTypes.QUESTIONS_FETCH_SUCCESS: {
      // console.log('QUESTIONS_FETCH_SUCCESS');
      // console.log(action.questions);
      // console.log(action.additionalQuestions);
      MemberStore.addQuestionsData(action.questions, action.additionalQuestions);
      MemberStore.emitChangeQuestion();
      break;
    }
    case ActionTypes.MEMBER_QUESTIONS_LOAD_SUCCESS: {
      MemberStore.addMemberQuestions(action.id, action.questions);
      MemberStore.emitChangeMemberQuestions();
      break;
    }
    default:
      // do nothing
  }
});

module.exports = MemberStore;
